import React from "react";
import { CustomTextField } from "../../components/TextFields";
import { Button } from "@mui/material";
import { ModalButtonContainer, NegativeModalButton, PositiveModalButton } from "../../components/Button";
import { useModal } from "../../components/modal";
import TextEditor from "../../components/editor/textEditor";

export default function AddModal() {
    const { setShow } = useModal()
    return (
        <React.Fragment>
            <CustomTextField
                required
                label="عنوان"
                placeholder="عنوان را وارد کنید."
                variant="outlined"
            />
            <CustomTextField
                required
                label="slug"
                placeholder="slug را وارد کنید."
                variant="outlined"
            />
            <CustomTextField
                required
                label="توضیحات"
                placeholder="توضیحات را وارد کنید."
                variant="outlined"
                multiline
                minRows={2}
                maxRows={4}
            />
            <TextEditor />&nbsp;&nbsp;
            <ModalButtonContainer>
                <Button
                    style={NegativeModalButton}
                    sx={{
                        color: "divider",
                        bgcolor: "primary.main",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        borderColor: "divider",
                        ":hover": {
                            bgcolor: "divider",
                            color: "primary.main"
                        },
                    }}
                    onClick={() => setShow(false)}
                >
                    انصراف
                </Button>
                <Button
                    style={PositiveModalButton}
                    sx={{
                        ":hover": {
                            bgcolor: "customColors.purple",
                            color: "secondary.main"
                        },
                    }}
                >
                    تایید
                </Button>
            </ModalButtonContainer >
        </React.Fragment>
    )
}